import React, { useState, useEffect } from 'react'
import { Alink, RouteButton } from '../libs/module'
import Lnb from './lnb'

const Menu = ({ fixMode, miniShopInfo, isMinishopDetail }) => {
    const location = window.location
    const host = location.hostname.split('.')[0]

    let topClassName = 'HBottom bdTe5 inactive'
    if (window.isMainDisplay) {
        topClassName = 'HBottom bdTe5'
    }

    const [activeMenu, setActiveMenu] = useState(null)
    const [isMiniShopDetail, setIsMiniShopDetail] = useState(isMinishopDetail)

    useEffect(() => {
        menuActiveSet()

        window.addEventListener('onSetActiveMenu', menuActiveSet)
        return () => {
            window.removeEventListener('onSetActiveMenu', menuActiveSet)
        }
    }, [])

    // active 매뉴추가 (2877)
    const menuActiveSet = () => {
        const pathName = window.location.pathname.split('/')
        if (window.isStdpc) {
            if (pathName[2]?.slice(0, 3) === '201') {
                setActiveMenu('stdpc_201')
            } else if (pathName[2]?.slice(0, 3) === '203') {
                setActiveMenu('stdpc_203')
            } else if (pathName[2]?.slice(0, 3) === '204') {
                setActiveMenu('stdpc_204')
            } else if (pathName[2]?.slice(0, 3) === '206') {
                setActiveMenu('stdpc_206')
            } else if (pathName[2] === 'srch') {
                setActiveMenu('srch')
            } else if (pathName[2] === 'all') {
                setActiveMenu('srch')
            } else if (pathName[3] === '2877') {
                setActiveMenu('stdpc_detail3')
            } else if (pathName[3] === '2865') {
                setActiveMenu('stdpc_detail1')
            } else if (pathName[3] === '2868') {
                setActiveMenu('stdpc_detail2')
            } else if (pathName[1] === 'event') {
                setActiveMenu('stdpc_event')
            } else if (!pathName[2]) {
                setActiveMenu('stdpc')
            }
        } else if (host === 'event' || host === 'event1') {
            setActiveMenu('event')
        } else {
            setActiveMenu(host)
        }
    }

    useEffect(() => {
        const firstPath = location.pathname.split("/")[1]
        let miniShopNumber = '1'
        if (firstPath === 'detail') {
            miniShopNumber = location.pathname.split("/")[3]
            if (miniShopNumber === '1' || miniShopNumber === '3'){
                setIsMiniShopDetail(false)
            }
        }
    },[location.pathname])

    return (
        <div className={topClassName}>
            <div className="HBBody">
                <Lnb fixMode={fixMode} activeLnb={miniShopInfo.f_auth_unit} isMinishopDetail={isMiniShopDetail} />
                <nav className="HBBgnb" style={!window.isStdpc&&(host !== 'minishop' && !isMiniShopDetail) ? { marginLeft: '203px' } : {}}>
                    <h2 className="blind outlineTxt">메뉴</h2>
                    <ul onClick={menuActiveSet}>
                        {/* 무이자24, 오로라PC 배포*/}
                        {window.isStdpc && (
                            <>
                                <li>
                                    <RouteButton to="/" className={`${activeMenu === 'stdpc' ? 'active' : ''}`}>
                                        홈
                                    </RouteButton>
                                </li>
                                <li>
                                    <a href={process.env.REACT_APP_STDPC_URL + '/list/2010000000'} className={`${activeMenu === 'stdpc_201' ? 'active' : ''}`}>
                                        표준PC
                                    </a>
                                </li>
                                <li>
                                    <a href={process.env.REACT_APP_STDPC_URL + '/list/2040000000'} className={`${activeMenu === 'stdpc_204' ? 'active' : ''}`}>
                                        무이자24
                                        {/*<img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_new_2.png`} alt="new" style={{ marginTop: '-3px' }} />*/}
                                    </a>
                                </li>
                                <li>
                                    <a href={process.env.REACT_APP_STDPC_URL + '/list/2060000000'} className={`${activeMenu === 'stdpc_206' ? 'active' : ''}`}>
                                        오로라PC
                                        <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_new_2.png`} alt="new" style={{ marginTop: '-3px' }} />
                                    </a>
                                </li>
                                <li>
                                    <a href={process.env.REACT_APP_STDPC_URL + "/list/2030000000"} className={`${activeMenu === 'stdpc_203' ? 'active' : ''}`}>
                                        게임별PC
                                        {/* <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_new_2.png`} alt="new" style={{ marginTop: '-3px' }} /> */}
                                    </a>
                                </li>
                                <li>
                                    <a href={process.env.REACT_APP_STDPC_URL+'/list/srch'} className={`${activeMenu === 'srch' ? 'active' : ''}`}>
                                        PC검색
                                    </a>
                                </li>

                                {/*<li>*/}
                                {/*    <a href="https://stdpc.pping.kr/event/detail/2865" className={`${activeMenu === 'stdpc_detail1' ? 'active' : ''}`}>*/}
                                {/*        Intel*/}
                                {/*    </a>*/}
                                {/*</li>*/}
                                <li>
                                    <a href="https://stdpc.pping.kr/event/detail/2868" className={`${activeMenu === 'stdpc_detail2' ? 'active' : ''}`}>
                                        AMD
                                    </a>
                                </li>
                                <li>
                                    <RouteButton to="/event" className={`${activeMenu === 'stdpc_event' ? 'active' : ''}`}>
                                        기획전
                                    </RouteButton>
                                </li>
                            </>
                        )}
                        {/* 메인 */}
                        {!window.isStdpc && (
                            // 미니샵 또는 미니샵 상세페이지 일 때
                            <>
                                {(host === 'minishop' || isMiniShopDetail) && (
                                    <>
                                        {miniShopInfo.f_estimate === 0 && miniShopInfo.f_deal === 0 && miniShopInfo.f_pc === 0 && (
                                        <li/>
                                        )}
                                        {miniShopInfo.f_estimate === 1 && (
                                        <li>
                                            <Alink href={`${process.env.REACT_APP_MINISHOP_URL}/${miniShopInfo.mall_web_user}`} target='_self' className={`${activeMenu === 'pc' ? 'active' : ''}`}>
                                                PC견적
                                            </Alink>
                                        </li>
                                        )}
                                        {miniShopInfo.f_pc === 1 && (
                                        <li>
                                            <Alink href={`${process.env.REACT_APP_STDPC_URL}/list/minishop/${miniShopInfo.idx_b_manager}`}>
                                                조립PC
                                            </Alink>
                                        </li>
                                        )}
                                        {miniShopInfo.f_deal === 1 && (
                                        <li>
                                            <Alink href={`${process.env.REACT_APP_DEAL_URL}/#store${miniShopInfo.idx_b_manager}`}>
                                                행복핫딜
                                            </Alink>
                                        </li>
                                        )}
                                    </>
                                )}
                                {/* 무이자24, 오로라PC 추가*/}
                                {host !== 'minishop' && !isMiniShopDetail && (
                                    <>
                                        <li>
                                            <Alink
                                                href={process.env.REACT_APP_PC_URL}
                                                className={`${activeMenu === 'pc' ? 'active' : ''}`}
                                            >
                                                PC견적
                                            </Alink>
                                        </li>
                                        <li style={{marginLeft: '28px'}}>
                                            <Alink
                                                href={process.env.REACT_APP_STDPC_URL + '/list/2010000000'}
                                                className={`${activeMenu === 'stdpc_201' ? 'active' : ''}`}
                                            >
                                                표준PC
                                                {/* <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_beta.png`} alt="beta" style={{ marginTop: '-3px' } */}
                                            </Alink>
                                        </li>
                                        <li style={{marginLeft: '28px'}}>
                                            <Alink
                                                href={process.env.REACT_APP_STDPC_URL + '/list/2040000000'}
                                                className={`${activeMenu === 'stdpc_204' ? 'active' : ''}`}
                                            >
                                                무이자24
                                                {/*<img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_new_2.png`} alt="new" style={{ marginTop: '-3px' }} />*/}
                                            </Alink>
                                        </li>
                                        {/* 오로라PC 삭제 (대표님 요청)*/}
                                        {/* <li>
                                            <Alink
                                                href={process.env.REACT_APP_STDPC_URL + '/list/2060000000'} className={`${activeMenu === 'stdpc_206' ? 'active' : ''}`}
                                            >
                                                오로라PC
                                                <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_new_2.png`} alt="new" style={{ marginTop: '-3px' }} />
                                            </Alink>
                                        </li> */}
                                        <li style={{marginLeft:'28px'}}>
                                            <Alink
                                                href={process.env.REACT_APP_STDPC_URL + '/list/2030000000'}
                                                className={`${activeMenu === 'stdpc' ? 'active' : ''}`}
                                            >
                                                게임별PC
                                                {/* <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_new_2.png`} alt="new" style={{ marginTop: '-3px' }} /> */}
                                            </Alink>
                                        </li>
                                        <li style={{marginLeft:'28px'}}>
                                            <Alink
                                                href={process.env.REACT_APP_STDPC_URL + '/list/srch'}
                                                className={`${activeMenu === 'stdpc' ? 'active' : ''}`}
                                            >
                                                PC검색
                                                {/* <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_new.png`} alt="new" style={{ marginTop: '-3px' }} /> */}
                                            </Alink>
                                        </li>
                                        {/*<li>*/}
                                        {/*    <Alink*/}
                                        {/*        href={process.env.REACT_APP_NOTEBOOK_URL}*/}
                                        {/*        className={`${activeMenu === 'notebook' ? 'active' : ''}`}*/}
                                        {/*    >*/}
                                        {/*        노트북 /!* <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_new.png`} alt="new" style={{ marginTop: '-3px' }} /> *!/*/}
                                        {/*    </Alink>*/}
                                        {/*</li>*/}
                                        <li style={{marginLeft:'28px'}}>
                                            <Alink
                                                href={process.env.REACT_APP_TALK_URL}
                                                className={`${activeMenu === 'talk' ? 'active' : ''}`}
                                            >
                                                톡톡 커뮤니티
                                                <img
                                                    src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_new_2.png`}
                                                    alt="new" style={{position:"initial",marginTop:'-9px',marginLeft:'2px'}}/>
                                            </Alink>
                                        </li>
                                        <li style={{marginLeft:'28px'}}>
                                            <Alink
                                                href={process.env.REACT_APP_DEAL_URL}
                                                className={`${activeMenu === 'deal' ? 'active' : ''}`}
                                            >
                                                행복핫딜 {/* <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/ic_new.png`} alt="new" style={{ marginTop: '-3px' }} /> */}
                                            </Alink>
                                        </li>
                                        <li style={{marginLeft:'28px'}}>
                                            <Alink
                                                href={process.env.REACT_APP_EVENT_URL}
                                                className={`${activeMenu === 'event' ? 'active' : ''}`}
                                            >
                                                이벤트&기획전
                                            </Alink>
                                        </li>
                                    </>
                                )}
                            </>
                        )}
                    </ul>
                </nav>
                <div className="itemNav"></div>
            </div>
        </div>
    )
}

export default Menu



// WEBPACK FOOTER //
// ./src/header/component/menu.js